<template>
    <div class="d-flex flex-row">
        <strong class="d-flex pa-1 property-box-shadow flex-column w-50 justify-center">
            {{ property }}
        </strong>
        <div class="d-flex flex-column ml-2 flex-grow-1 justify-center">
            {{ value }}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'user-wizard-property',
        props: {
            property: String,
            value: String
        }
    }
</script>

<style scoped>
    .property-box-shadow {
        box-shadow: inset 0 0 0 9999px rgba(0, 0, 0, 0.15);
    }
</style>
